import '../../Styles/OutilsTest/general.css';
import {useLang} from '../../../../_metronic/i18n/Metronici18n';

const IperfFr = () => (
  <div className="outile-container">
    <h2 className="page-title">Mesure de la performance réseau avec Iperf</h2>

    <section className="section">
      <h3>Principe de fonctionnement</h3>
      <p>Iperf doit être lancé sur deux machines se trouvant de part et d'autre du réseau à tester.</p>
      <p>
        CELESTE a déjà une instance d'Iperf lancée sur son réseau, vous n'avez plus qu'à lancer le client Iperf de votre côté pour mesurer la performance entre votre emplacement et le cœur de réseau CELESTE.
        Attention, veillez à bien utiliser la <span className="strong">version 2</span> de Iperf.
      </p>
      <p>CELESTE met à votre disposition 2 serveurs :</p>

      <div className="table-wrapper">
        <table className="styled-table">
          <thead>
            <tr>
              <th></th>
              <th>Serveur 1</th>
              <th>Serveur 2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>DNS</td>
              <td>iperf1.celeste.fr</td>
              <td>iperf2.celeste.fr</td>
            </tr>
            <tr>
              <td>Adresse IP</td>
              <td>178.16.168.33</td>
              <td>178.16.168.35</td>
            </tr>
            <tr>
              <td>Version</td>
              <td>Version 2</td>
              <td>Version 2</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        Vous pouvez également utiliser des serveurs publics pour réaliser vos tests, dont la liste est
        disponible sur <a href="https://iperf.fr/iperf-servers.html" target="_blank" rel="noreferrer">le site d'Iperf</a>.
      </p>

      <h4>Ouverture des ports</h4>
      <ul>
        <li>Les tests TCP se font sur le port 5001</li>
        <li>Les tests UDP se font sur le port 5002</li>
      </ul>
      <p>
        Pour le test du download, il faut que les ports TCP/5001 et UDP/5002 soient ouverts pour que les flux puissent revenir. Il est donc obligatoire de configurer une redirection de port sur le StarQos vers votre ordinateur de test ou de vous connecter en mode transparent.<br/>
        Les redirections de port peuvent être demandées par simple demande au support technique de CELESTE. Pour accélérer le processus veuillez nous indiquer les ports TCP/5001 et UDP/5002 et l'IP de votre ordinateur de test.<br/>
      </p>

      <h3>Utilisation</h3>

      <h4>Exemple 1 - Test de l'upload</h4>
      <div className="command-block">
        <div className="command-title">Commande : iperf -c iperf1.celeste.fr -m -i 10 -t 30</div>
        <pre className="code-block">{`------------------------------------------------------------
Client connecting to iperf1.celeste.fr, TCP port 5001
TCP window size: 85.0 KByte (default)
------------------------------------------------------------
[  3] local 192.168.52.3 port 57113 connected with 178.16.168.33 port 5001
[ ID] Interval       Transfer     Bandwidth
[  3]  0.0-10.0 sec  1.08 GBytes   926 Mbits/sec
[  3] 10.0-20.0 sec  1.08 GBytes   926 Mbits/sec
[  3] 20.0-30.0 sec  1.08 GBytes   928 Mbits/sec
[  3]  0.0-30.0 sec  3.24 GBytes   926 Mbits/sec
[  3] MSS size 1448 bytes (MTU 1500 bytes, ethernet)`}</pre>
      </div>
      <br/>
      <h4>Exemple 2 - Upload + Download</h4>
      <div className="command-block">
        <div className="command-title">Commande : iperf -c iperf1.celeste.fr -m -i 10 -t 30 -r</div>
        <pre className="code-block">{`------------------------------------------------------------
Server listening on TCP port 5001
TCP window size: 85.3 KByte (default)
------------------------------------------------------------
Client connecting to iperf1.celeste.fr, TCP port 5001
TCP window size:  212 KByte (default)
------------------------------------------------------------
[  5] local 192.168.52.3 port 57130 connected with 178.16.168.33 port 5001
[ ID] Interval       Transfer     Bandwidth
[  5]  0.0-10.0 sec  1.08 GBytes   928 Mbits/sec
[  5] 10.0-20.0 sec  1.08 GBytes   927 Mbits/sec
[  5] 20.0-30.0 sec  1.08 GBytes   927 Mbits/sec
[  5]  0.0-30.0 sec  3.24 GBytes   927 Mbits/sec
[  5] MSS size 1448 bytes (MTU 1500 bytes, ethernet)`}</pre>
      </div>
      <br/>
      <h4>Exemple 3 - Test UDP</h4>
      <p>
        Dans le cas du test UDP, il faut ajouter <code>-u</code> et définir la bande passante, par ex. <code>-b 10m</code>.
      </p>
      <div className="command-block">
        <div className="command-title">Commande : iperf -u -p 5002 -c iperf1.celeste.fr -m -i 10 -t 30 -b 10m</div>
        <pre className="code-block">{`------------------------------------------------------------
Client connecting to iperf1.celeste.fr, UDP port 5002
Sending 1470 byte datagrams
UDP buffer size:  208 KByte (default)
------------------------------------------------------------
[  3] local 192.168.52.3 port 48527 connected with 178.16.168.33 port 5002
[ ID] Interval       Transfer     Bandwidth
[  3]  0.0-10.0 sec  11.9 MBytes  10.0 Mbits/sec
[  3] 10.0-20.0 sec  11.9 MBytes  10.0 Mbits/sec
[  3] 20.0-30.0 sec  11.9 MBytes  10.0 Mbits/sec
[  3]  0.0-30.0 sec  35.8 MBytes  10.0 Mbits/sec
[  3] Sent 25512 datagrams
[  3] Server Report:
[  3]  0.0-30.0 sec  35.8 MBytes  10.0 Mbits/sec   0.023 ms    0/25511 (0%)
[  3]  0.0-30.0 sec  1 datagrams received out-of-order`}</pre>
      </div>
      <br/>
      <p>
        Pour une utilisation avancée d'Iperf, nous vous recommandons de consulter la <a href="https://iperf.fr/iperf-doc.html#doc" target="_blank" rel="noreferrer">documentation en ligne</a>.
      </p>
    </section>
  </div>
);

const IperfEn = () => (
  <div className="outile-container">
    <h2 className="page-title">Network performance measurement with Iperf</h2>

    <section className="section">
      <h3>How it works</h3>
      <p>Iperf must be launched on two machines located on either side of the network to be tested.</p>
      <p>
        CELESTE already has an Iperf instance running on its network. You just need to launch the Iperf client on your side to measure performance between your location and the CELESTE network core.
        Note: make sure to use <span className="strong">version 2</span> of Iperf.
      </p>
      <p>CELESTE provides 2 servers:</p>

      <div className="table-wrapper">
        <table className="styled-table">
          <thead>
            <tr>
              <th></th>
              <th>Server 1</th>
              <th>Server 2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>DNS</td>
              <td>iperf1.celeste.fr</td>
              <td>iperf2.celeste.fr</td>
            </tr>
            <tr>
              <td>IP Address</td>
              <td>178.16.168.33</td>
              <td>178.16.168.35</td>
            </tr>
            <tr>
              <td>Version</td>
              <td>Version 2</td>
              <td>Version 2</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        You can also use public servers for your tests. A list is available on the <a href="https://iperf.fr/iperf-servers.html" target="_blank" rel="noreferrer">Iperf website</a>.
      </p>

      <h4>Port requirements</h4>
      <ul>
        <li>TCP tests use port 5001</li>
        <li>UDP tests use port 5002</li>
      </ul>
      <p>
        For download testing, ports TCP/5001 and UDP/5002 must be open for return traffic. You must configure a port redirect on the StarQos toward your test machine, or connect in transparent mode.<br/>
        Port redirects can be requested from CELESTE technical support. To speed up the process, please provide ports TCP/5001 and UDP/5002 along with your test machine's IP address.<br/>
      </p>

      <h3>Usage</h3>

      <h4>Example 1 - Upload test</h4>
      <div className="command-block">
        <div className="command-title">Command: iperf -c iperf1.celeste.fr -m -i 10 -t 30</div>
        <pre className="code-block">{`------------------------------------------------------------
Client connecting to iperf1.celeste.fr, TCP port 5001
TCP window size: 85.0 KByte (default)
------------------------------------------------------------
[  3] local 192.168.52.3 port 57113 connected with 178.16.168.33 port 5001
[ ID] Interval       Transfer     Bandwidth
[  3]  0.0-10.0 sec  1.08 GBytes   926 Mbits/sec
[  3] 10.0-20.0 sec  1.08 GBytes   926 Mbits/sec
[  3] 20.0-30.0 sec  1.08 GBytes   928 Mbits/sec
[  3]  0.0-30.0 sec  3.24 GBytes   926 Mbits/sec
[  3] MSS size 1448 bytes (MTU 1500 bytes, ethernet)`}</pre>
      </div>
      <br/>
      <h4>Example 2 - Upload + Download</h4>
      <div className="command-block">
        <div className="command-title">Command: iperf -c iperf1.celeste.fr -m -i 10 -t 30 -r</div>
        <pre className="code-block">{`------------------------------------------------------------
Server listening on TCP port 5001
TCP window size: 85.3 KByte (default)
------------------------------------------------------------
Client connecting to iperf1.celeste.fr, TCP port 5001
TCP window size:  212 KByte (default)
------------------------------------------------------------
[  5] local 192.168.52.3 port 57130 connected with 178.16.168.33 port 5001
[ ID] Interval       Transfer     Bandwidth
[  5]  0.0-10.0 sec  1.08 GBytes   928 Mbits/sec
[  5] 10.0-20.0 sec  1.08 GBytes   927 Mbits/sec
[  5] 20.0-30.0 sec  1.08 GBytes   927 Mbits/sec
[  5]  0.0-30.0 sec  3.24 GBytes   927 Mbits/sec
[  5] MSS size 1448 bytes (MTU 1500 bytes, ethernet)`}</pre>
      </div>
      <br/>
      <h4>Example 3 - UDP test</h4>
      <p>
        For UDP testing, add <code>-u</code> and define the bandwidth, e.g. <code>-b 10m</code>.
      </p>
      <div className="command-block">
        <div className="command-title">Command: iperf -u -p 5002 -c iperf1.celeste.fr -m -i 10 -t 30 -b 10m</div>
        <pre className="code-block">{`------------------------------------------------------------
Client connecting to iperf1.celeste.fr, UDP port 5002
Sending 1470 byte datagrams
UDP buffer size:  208 KByte (default)
------------------------------------------------------------
[  3] local 192.168.52.3 port 48527 connected with 178.16.168.33 port 5002
[ ID] Interval       Transfer     Bandwidth
[  3]  0.0-10.0 sec  11.9 MBytes  10.0 Mbits/sec
[  3] 10.0-20.0 sec  11.9 MBytes  10.0 Mbits/sec
[  3] 20.0-30.0 sec  11.9 MBytes  10.0 Mbits/sec
[  3]  0.0-30.0 sec  35.8 MBytes  10.0 Mbits/sec
[  3] Sent 25512 datagrams
[  3] Server Report:
[  3]  0.0-30.0 sec  35.8 MBytes  10.0 Mbits/sec   0.023 ms    0/25511 (0%)
[  3]  0.0-30.0 sec  1 datagrams received out-of-order`}</pre>
      </div>
      <br/>
      <p>
        For advanced Iperf usage, we recommend consulting the <a href="https://iperf.fr/iperf-doc.html#doc" target="_blank" rel="noreferrer">online documentation</a>.
      </p>
    </section>
  </div>
);

const Iperf = () => {
  const lang = useLang();
  return lang === 'en' ? <IperfEn /> : <IperfFr />;
};

export default Iperf;
